const configuredApiBase = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

function defaultApiBase() {
  if (configuredApiBase) return configuredApiBase;
  if (typeof window === "undefined") return "";

  const { hostname, port } = window.location;
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
  if (process.env.NODE_ENV === "production" && isLocalHost && port && port !== "5050") {
    return `http://${hostname}:5050`;
  }

  return "";
}

export function apiUrl(path) {
  if (/^https?:\/\//i.test(path)) return path;
  return `${defaultApiBase()}${path}`;
}
